import { render, staticRenderFns } from "./SettingsFeaturesPayLink.vue?vue&type=template&id=5fba77fa&scoped=true"
import script from "./SettingsFeaturesPayLink.vue?vue&type=script&lang=js"
export * from "./SettingsFeaturesPayLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fba77fa",
  null
  
)

export default component.exports